module.exports = new Promise(resolve => {
      const src = window.AppConfig.SYNCHRONIZATION_SETTINGS_UI_URL + "/remoteEntry.js"
      const script = document.createElement('script')
      script.src = src
       
       script.onload = () => {
        const proxy = {
          get: (request) => window.codat_synchronization_settings_ui.get(request),
          init: (arg) => {
            try {
              return window.codat_synchronization_settings_ui.init(arg)
            } catch(e) {
              console.error(e)
            }
          }
        }
        resolve(proxy)
      }
      script.onerror = () => {
        console.error("Failed to load " + src)
        resolve()
      }
      document.head.appendChild(script);
    });